import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  private scrollToServicesSubject = new Subject<void>();
  private scrollToCommentsSubject = new Subject<void>();

  scrollToServices$ = this.scrollToServicesSubject.asObservable();

  emitScrollToServices() {
    this.scrollToServicesSubject.next();
  }

  scrollToComments$ = this.scrollToCommentsSubject.asObservable();

  emitScrollToComments() {
    this.scrollToCommentsSubject.next();
  }
}